import { FunctionComponent, useEffect, useState } from 'react'

import { Grid } from '@material-ui/core'

import { MdClose } from 'react-icons/md'
import CustomModal from './CustomModal'
import { CardsContainer, CloseButton, Paragraph, Title } from './styles'
import { colors } from 'shared/styles/colors'
import CardFrotistaSemContaPay from './CardFrotistaSemContaPay'
import { cnpjMask } from 'shared/utils/formatters'
import { useDirecionaCarga } from 'modules/lotes/hooks/direcionaCarga'
import Button from 'shared/components/Button'
import Frotista from 'modules/user/domain/entities/Frotista'
import EStatusConta from 'modules/lotes/domain/entities/EStatusConta'

export enum ERequisitosViagem {
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  OK = 'OK',
}

interface TProps {
  openModalRequisitos: boolean
  setOpenModalRequisitos: (value: boolean) => void
  frotistas: Frotista[]
  direcionamentoCarga: (loteId, origem, destino) => Promise<void>
}
const ModalMultiplosCnpjsRequisitosViagem: FunctionComponent<TProps> = ({
  openModalRequisitos,
  setOpenModalRequisitos,
  frotistas,
  direcionamentoCarga,
}) => {
  const { lote } = useDirecionaCarga()
  const [botaoDesabilitado, setBotaoDesabilitado] = useState(true)
  const continuar = () => {
    setOpenModalRequisitos(false)
    direcionamentoCarga(lote.id, lote.origem, lote.destino)
  }

  useEffect(() => {
    let podeContinuar = false
    if (frotistas) {
      frotistas.forEach(frotista => {
        if (
          frotista.status_conta === EStatusConta.ATIVA ||
          frotista.status_conta === EStatusConta.CONTA_NAO_NECESSARIA
        ) {
          podeContinuar = true
        }
      })
    }
    setBotaoDesabilitado(!podeContinuar)
  }, [frotistas, botaoDesabilitado])

  return (
    <CustomModal
      openModal={openModalRequisitos}
      showCloseButton={false}
      onCloseModal={() => setOpenModalRequisitos(false)}
    >
      <Grid container>
        <Grid item lg={10} md={10} sm={10}>
          <Title>Este(s) CNPJ não tem uma conta de pagamentos</Title>
        </Grid>
        <Grid item lg={2}>
          <CloseButton onClick={() => setOpenModalRequisitos(false)}>
            <MdClose size={30} />
          </CloseButton>
        </Grid>

        <Grid item lg={12}>
          <Paragraph>
            A criação da conta é um requisito obrigatório para solicitar fretes
            dentro da plataforma, é através dela que você recebe.
          </Paragraph>
        </Grid>
      </Grid>

      <CardsContainer>
        {frotistas &&
          frotistas.map(
            (frotista, key) =>
              ![EStatusConta.ATIVA, EStatusConta.CONTA_NAO_NECESSARIA].includes(
                frotista.status_conta,
              ) && (
                <CardFrotistaSemContaPay
                  key={key}
                  razaoSocial={frotista.razao_social}
                  cnpj={cnpjMask(frotista.cnpj)}
                  mensagemStatusConta={frotista.mensagem_status_conta}
                  statusConta={frotista.status_conta}
                ></CardFrotistaSemContaPay>
              ),
          )}
      </CardsContainer>

      <Button
        onClick={continuar}
        color={botaoDesabilitado ? colors.grayLight : colors.green}
        style={{ width: '90%' }}
        disabled={botaoDesabilitado}
      >
        Continuar
      </Button>
    </CustomModal>
  )
}

export default ModalMultiplosCnpjsRequisitosViagem
